import { Component, Prop } from 'vue-property-decorator'
import { KhIcon, Nullable, KhText, KhAnimationProps } from '@internal-libraries/kheops-ui-lib'
import {
    CANCELLED_ICON_COLOR,
    DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
    SEX_COLOR_FEMALE,
    SEX_COLOR_MALE,
} from '../../const'
import { ClvrScreenControlHeadersLabelsEnum } from '../../enum'
import ClvrScreenControlDataCell from '../ClvrScreenControlDataCell'
import { DEFAULT_HEIGHT_CONTAINER_SMALL } from '../../../../const'
import ScreenResolutionHelper from '../../../../../../system/vue/Classes/ScreenResolutionHelper'

@Component({
    components: {
        KhIcon,
        KhText,
    },
})
export default class ClvrScreenControlPatientCell extends ClvrScreenControlDataCell {
    @Prop({ type: String, default: '' })
    public firstName!: string
    @Prop({ type: String, default: '' })
    public lastName!: string
    @Prop({ type: String, default: '' })
    public admission!: string
    @Prop({ type: Number, default: null })
    public age!: Nullable<number>
    @Prop({ type: String, default: null })
    public room!: Nullable<string>
    @Prop({ type: String, default: '' })
    public sex!: string
    @Prop({ type: String, default: '' })
    public service!: string
    @Prop({ type: String, default: '' })
    public isolationType!: string
    @Prop({ type: Boolean, default: false })
    public cancelledOperation!: boolean

    private readonly MALE = 'M'
    private readonly FEMALE = 'F'
    public readonly iconSize = 15

    public get ClvrScreenControlHeadersLabelsEnum() {
        return ClvrScreenControlHeadersLabelsEnum
    }

    public get patientNameVisibility() {
        return (
            this.getDataTypeVisibility([ClvrScreenControlHeadersLabelsEnum.PATIENT]) &&
            (this.getDataTypeVisibility([ClvrScreenControlHeadersLabelsEnum.PATIENT_FIRSTNAME]) ||
                this.getDataTypeVisibility([ClvrScreenControlHeadersLabelsEnum.PATIENT_LASTNAME]))
        )
    }

    public getPatientDataTypeVisibility(patientDataType: ClvrScreenControlHeadersLabelsEnum): boolean {
        return this.getDataTypeVisibility([ClvrScreenControlHeadersLabelsEnum.PATIENT, patientDataType])
    }

    public get fullName(): string {
        return [
            this.getDataTypeVisibility('firstname_patient') ? this.firstName : null,
            this.getDataTypeVisibility('lastname_patient') ? this.lastName : null,
        ]
            .filter(item => !!item)
            .join(' ')
    }

    public get othersInfo(): string {
        return [
            this.getDataTypeVisibility('service_patient') ? this.service : null,
            this.getDataTypeVisibility('nb_room_patient') ? this.room : null,
            this.getDataTypeVisibility('admission_type_patient') ? this.admission : null,
            this.getDataTypeVisibility('isol_info_patient') ? this.isolationType : null,
        ]
            .filter(item => !!item)
            .join(' - ')
    }

    public get genderIcon(): string {
        switch (this.sex.toUpperCase()) {
            case this.MALE:
                return 'mdi-gender-male'
            case this.FEMALE:
                return 'mdi-gender-female'
            default:
                return ''
        }
    }

    public get genderColor(): string {
        if (this.cancelledOperation) {
            return CANCELLED_ICON_COLOR
        }
        return this.sex.toUpperCase() === this.MALE ? SEX_COLOR_MALE : SEX_COLOR_FEMALE
    }

    public get getAge(): string {
        return this.age ? this.$t('clevehr:year_old', { count: this.age }) : ''
    }

    public get fullNameAnimationRightToLeftProps(): Nullable<KhAnimationProps> {
        return !this.printMode
            ? {
                  ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
                  text: this.fullName,
                  containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER_SMALL),
              }
            : null
    }

    public get othersInfoAnimationRightToLeftProps(): Nullable<KhAnimationProps> {
        return !this.printMode
            ? {
                  ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
                  text: this.othersInfo,
                  containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER_SMALL),
              }
            : null
    }

    public get genderIconSize(): number {
        return ScreenResolutionHelper.getSizeFor4KResolution(this.iconSize)
    }
}
